"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const uiStatePersistencyMap = {};
exports.uiStatePersistence = (scope, editableId) => () => ({
    actions: {
        uiStatePersistence: {
            restoreState: (state, actions, uiState) => {
                return Object.assign({}, state, { _uiStatePersistenceImported: true, ui: Object.assign({}, state.ui, uiState) });
            },
        },
    },
    events: {
        load(state, actions) {
            actions.uiStatePersistence.restoreState(uiStatePersistencyMap[`${scope}:${editableId}`]);
        },
        resolve(state, actions, newState) {
            if (newState && newState.ui && newState._uiStatePersistenceImported) {
                uiStatePersistencyMap[`${scope}:${editableId}`] = newState.ui;
            }
        },
    },
});
//# sourceMappingURL=ui-state-persistence.js.map